import React,{InputHTMLAttributes} from "react";
import { Content } from './styles'

interface Props extends InputHTMLAttributes<HTMLInputElement>{
    placeholder: string;
}
export function Input({ placeholder, ...rest } : Props){
    return(
        <Content   { ...rest} placeholder={placeholder} />
    )
}